// extracted by mini-css-extract-plugin
export default {"virtual":"Virtual_virtual__h-NHa","left":"Virtual_left__e3BaY","wrapper":"Virtual_wrapper__GIArz","right":"Virtual_right__r8FY8"};